import { GzUninstallAgentWebComponent } from './component/GzUninstallAgentWebComponent';

export { GzUninstallAgentWebComponent };
